import {useEffect, useState} from "react";
import {Dashboard, DashboardComponentState} from "../../components/pages/dashboard/components/interfaces";

export const useComponentStateCallback = (componentProps: Dashboard.DashboardComponentPropsBase) => {
    const [state, setState] = useState<Partial<DashboardComponentState>>({state: "loading", id: componentProps.id});

    useEffect(() => {
        if (componentProps.stateCb) {
            componentProps.stateCb({...state, id: componentProps.id} as DashboardComponentState);
        }
    }, [state]);

    return setState;
}